import {Menu} from './menu-bar/types';
import {TranslateService} from '@ngx-translate/core';
import {ANY_ADMIN} from '../auth/admin-levels';

export class BuilderMenu {
    public static get(translate: TranslateService): Menu[] {
        return [
            {
                icon: 'fas fa-warehouse',
                label: translate.instant('menu.data-center.label'),
                automationId: ['DATASTORE', 'TABLES', 'DATAVIEWSETTINGS', 'TAGS', 'PROVIDERS'],
                pages: [
                    {
                        label: translate.instant('menu.data-center.datastores'),
                        path: 'settings/datastore',
                        automationId: ['DATASTORE'],
                    },
                    {
                        label: translate.instant('menu.data-center.tables'),
                        path: 'tables',
                        automationId: ['TABLES'],
                    },
                    {
                        label: translate.instant('menu.data-center.views'),
                        path: 'settings/view-editor',
                        automationId: ['DATAVIEWSETTINGS'],
                    },
                    {
                        label: translate.instant('menu.data-center.tags'),
                        path: 'settings/tags',
                        automationId: ['TAGS'],
                    },
                    {
                        label: translate.instant('menu.data-center.providers'),
                        path: 'settings/provider',
                        automationId: ['PROVIDERS'],
                    },
                ],
            },
            {
                icon: 'fab fa-confluence',
                label: translate.instant('menu.flow.label'),
                automationId: ['IMPORTS', 'EXPORTS'],
                pages: [
                    {
                        label: translate.instant('menu.flow.imports'),
                        path: 'flux/import-v1/etl',
                        automationId: ['IMPORTS'],
                    }, {
                        label: translate.instant('menu.flow.exports'),
                        path: 'flux/export/etl',
                        automationId: ['EXPORTS'],
                    },
                    {
                        label: translate.instant('menu.flow.dictionary'),
                        path: 'flux/import-v1/dico',
                        automationId: ['IMPORTS'],
                    },
                    {
                        label: translate.instant('menu.flow.tasks'),
                        path: 'flux/import-v1/task',
                        automationId: ['IMPORTS', 'EXPORTS'],
                    },
                ]
            },
            {
                icon: 'far fa-eye',
                label: translate.instant('menu.dataviews.label'),
                automationId: ['DATAVIEWS'],
                pages: [
                    {
                        label: translate.instant('menu.dataviews.purchases'),
                        path: 'view/command',
                        automationId: ['DATAVIEWS'],
                    },
                    {
                        label: translate.instant('menu.dataviews.contacts'),
                        path: 'view/personal',
                        automationId: ['DATAVIEWS'],
                    },
                    {
                        label: translate.instant('menu.dataviews.leads'),
                        path: 'view/lead',
                        automationId: ['DATAVIEWS'],
                    },
                    {
                        label: translate.instant('menu.dataviews.tag-events'),
                        path: 'tag/event',
                        automationId: ['DATAVIEWS'],
                    },
                ],
            },
            {
                icon: 'fas fa-envelope-open-text',
                label: translate.instant('menu.marketing.label'),
                automationId: ['CAMPAIGN', 'SUBSCRIPTIONS'],
                pages: [
                    {
                        label: translate.instant('menu.marketing.campaigns'),
                        path: 'marketing/campaign',
                        automationId: ['CAMPAIGN'],
                    },
                    {
                        label: translate.instant('menu.marketing.campaignGroups'),
                        path: 'marketing/campaign-group',
                        automationId: ['CAMPAIGN'],
                    },
                    {
                        label: translate.instant('menu.marketing.subscriptions'),
                        path: 'marketing/subscriptions',
                        automationId: ['SUBSCRIPTIONS'],
                    },
                ]
            },
            {
                icon: 'far fa-window-maximize',
                label: translate.instant('menu.landingpage.label'),
                automationId: ['HTML5TEMPLATE', 'LANDINGPAGECONFIGURATION'],
                pages: [
                    {
                        label: translate.instant('menu.landingpage.html-template'),
                        path: 'landing-page/page',
                        automationId: ['HTML5TEMPLATE'],
                    },
                    {
                        label: translate.instant('menu.landingpage.configuration'),
                        path: 'landing-page/config',
                        automationId: ['LANDINGPAGECONFIGURATION'],
                    },
                ]
            },
            // {
            //     icon: 'fas fa-chart-line',
            //     label: translate.instant('menu.statistics.label'),
            //     automationId: ['DATAVIEWS'],
            //     pages: [{
            //         path: 'statistics',
            //         label: translate.instant('menu.statistics.general'),
            //         automationId: ['DATAVIEWS'],
            //     }]
            // },
            {
                icon: 'fas fa-solid fa-paper-plane',
                label: translate.instant('menu.workflow.label'),
                automationId: ['WORKFLOW', 'HTMLBLOCK', 'EMAILTRANSACTIONAL'],
                pages: [
                    {
                        label: translate.instant('menu.workflow.settings'),
                        path: 'workflow',
                        automationId: ['WORKFLOW'],
                    },
                    {
                        label: translate.instant('menu.workflow.html-blocks'),
                        path: 'marketing/template',
                        automationId: ['HTMLBLOCK'],
                    },
                    {
                        label: translate.instant('menu.workflow.marketing-emails'),
                        path: 'marketing/marketing-email',
                        automationId: ['EMAILTRANSACTIONAL'],
                    }
                ],
            },
            {
                icon: 'fas fa-exchange-alt',
                label: translate.instant('menu.transfer.label'),
                automationId: ['TRANSFERS'],
                pages: [
                    {
                        label: translate.instant('menu.transfer.label'),
                        path: 'transfer',
                        automationId: ['TRANSFERS'],
                    },
                ],
            },
            {
                icon: 'fab fa-adn',
                label: translate.instant('menu.invoice.label'),
                automationId: ['INVOICECONTACTS', 'INVOICECOMPANIES'],
                pages: [
                    {
                        label: translate.instant('menu.invoice.companies'),
                        path: 'invoicing/company',
                        automationId: ['INVOICECOMPANIES'],
                    },
                    {
                        label: translate.instant('menu.invoice.contacts'),
                        path: 'invoicing/contact',
                        automationId: ['INVOICECONTACTS'],
                    },
                    {
                        label: translate.instant('menu.invoice.callForInvoicing'),
                        path: 'apps/call-for-invoicing',
                        automationId: ['INVOICE_CONTACTS'],
                    }
                ],
            },
            {
                icon: 'fas fa-user-plus',
                label: translate.instant('menu.admin.label'),
                automationId: [ANY_ADMIN, 'ROLES', 'API', 'TABLES'],
                pages: [
                    {
                        label: translate.instant('menu.admin.users'),
                        path: 'admin/user-management',
                        automationId: [ANY_ADMIN],
                    },
                    {
                        label: translate.instant('menu.admin.roles'),
                        path: 'admin/role',
                        automationId: ['ROLES'],
                    },
                    {
                        label: translate.instant('menu.admin.api'),
                        path: 'admin/docs',
                        automationId: ['API'],
                    },
                    {
                        label: translate.instant('menu.admin.maintenance'),
                        path: 'admin/maintenance',
                        automationId: ['API'],
                    },
                    {
                        label: translate.instant('menu.admin.bookingStatuses'),
                        path: 'admin/booking-statuses', automationId: ['TABLES'],
                    },
                ]
            },
            {
                icon: 'fas fa-chart-pie',
                label: translate.instant('menu.dashboards.label'),
                automationId: ['SUPERSET_DASHBOARD'],
                pages: [
                    {
                        label: translate.instant('menu.dashboards.tenant'),
                        path: 'dashboard/superset',
                        automationId: ['SUPERSET_DASHBOARD'],
                    },
                ],
            }
        ];
    }
}
